var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "form-container"
  }, [_c("a-card", {
    attrs: {
      hoverable: true,
      bordered: false
    }
  }, [_c("a-form-model", {
    ref: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.formRule,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("商品名称"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "type",
      label: _vm.$t("商品类型"),
      hasFeedback: ""
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("商品类型"),
      allowClear: ""
    },
    on: {
      change: _vm.changeType
    }
  }, _vm._l(_vm.typeOption, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.label)) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "weight",
      label: _vm.$t("重量"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("重量") + "（kg）"
    },
    model: {
      value: _vm.form.weight,
      callback: function ($$v) {
        _vm.$set(_vm.form, "weight", $$v);
      },
      expression: "form.weight"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "weight",
      label: _vm.$t("价格"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    model: {
      value: _vm.form.price,
      callback: function ($$v) {
        _vm.$set(_vm.form, "price", $$v);
      },
      expression: "form.price"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "date",
      label: _vm.$t("上架日期"),
      hasFeedback: ""
    }
  }, [_c("a-range-picker", {
    attrs: {
      placeholder: [_vm.$t("开始日期"), _vm.$t("结束日期")],
      allowClear: ""
    },
    on: {
      change: _vm.changTime
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否置顶"),
      prop: "recommend"
    }
  }, [_c("a-switch", {
    model: {
      value: _vm.form.topping,
      callback: function ($$v) {
        _vm.$set(_vm.form, "topping", $$v);
      },
      expression: "form.topping"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "text",
      label: _vm.$t("商品描述")
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("商品描述"),
      autoSize: {
        minRows: 3,
        maxRows: 5
      }
    },
    model: {
      value: _vm.form.text,
      callback: function ($$v) {
        _vm.$set(_vm.form, "text", $$v);
      },
      expression: "form.text"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "reviewer",
      label: _vm.$t("审核人")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.reviewer,
      callback: function ($$v) {
        _vm.$set(_vm.form, "reviewer", $$v);
      },
      expression: "form.reviewer"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "Siri"
    }
  }, [_vm._v(" Siri ")]), _c("a-radio", {
    attrs: {
      value: "Timi"
    }
  }, [_vm._v(" Timi ")])], 1)], 1), _c("a-form-model-item", {
    staticClass: "text-center",
    attrs: {
      "wrapper-col": {
        span: 24
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.addFormData
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加")) + " ")]), _c("a-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      click: _vm.resetFrom
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };